<div class="nova-font-style">
  <div class="top-margin-15"></div>
  <h2>View Employer Documents</h2>
  <div class="row">
    <div class="col s12 m12 l12 xl12">
      <kendo-grid [kendoGridBinding]="gridView" [pageSize]="10" [pageable]="true" [sortable]="true" [resizable]="true"
        [sort]="sort" id="emp-doc-history">
        <ng-template kendoGridToolbarTemplate>
          <input id="kendo-search" class="margin-5 float-right" placeholder="Search in all columns..." kendoTextBox
            (input)="onFilter($event.target.value)" />
        </ng-template>
        <!-- Mobile View -->
        <kendo-grid-column media="(max-width: 772.98px)" title="Details">
          <ng-template kendoGridCellTemplate let-dataItem>
            <!-- template for mobile -->
            <dl>
              <!-- Doc Name -->
              <dt>
                <div class="align-center">
                  <span class="bold">Document Name</span>
                </div>
              </dt>
              <dd>
                <div class="align-center">
                  {{ dataItem.docName }}
                </div>
              </dd>
              <!-- Doc Description -->
              <dt>
                <div class="align-center">
                  <span class="bold">Description</span>
                </div>
              </dt>
              <dd>
                <div class="align-center">
                  {{ dataItem.title }}
                </div>
              </dd>
              <!-- Doc Category -->
              <dt>
                <div class="align-center">
                  <span class="bold">Category</span>
                </div>
              </dt>
              <dd>
                <div class="align-center">
                  {{ dataItem.docCategory }}
                </div>
              </dd>
              <!-- Doc Type -->
              <dt>
                <div class="align-center">
                  <span class="bold">Document Type</span>
                </div>
              </dt>
              <dd>
                <div class="align-center">
                  {{ dataItem.docType }}
                </div>
              </dd>
              <!-- Last Modified Date -->
              <dt>
                <div class="align-center">
                  <span class="bold">Modified</span>
                </div>
              </dt>
              <dd>
                <div class="align-center">
                  {{ dataItem.modifiedDate | date:'MM/dd/yyyy hh:mm a'}}
                </div>
              </dd>
              <dd>
                <div class="align-center">
                  <span (click)="viewDoc(dataItem);dataItem.isClicked=!dataItem.isClicked" class="doc-view">
                    <span *ngIf="!dataItem.isClicked" class="k-icon k-i-file-pdf k-i-pdf"></span>
                    <a *ngIf="!dataItem.isClicked" class="clone-link">View</a>
                    <span *ngIf="dataItem.isClicked" class="k-icon k-i-loading inner"></span>
                  </span>
                </div>
              </dd>
            </dl>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column media="(min-width: 773px)" field="docName" title="Document Name" [width]="140">
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 773px)" field="title" title="Description" [width]="140">
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 773px)" field="docCategory" title="Category" [width]="140">
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 773px)" field="docType" title="Document Type" [width]="140">
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 773px)" field="modifiedDate" title="Modified" [width]="100"
          [headerClass]="{'align-date': true}">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-date">
              {{dataItem.modifiedDate | date:'MM/dd/yyyy hh:mm a'}}
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 773px)" title="" [width]="80" [resizable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="align-center">
              <span (click)="viewDoc(dataItem);dataItem.isClicked=!dataItem.isClicked" class="doc-view">
                <span *ngIf="!dataItem.isClicked" class="k-icon k-i-file-pdf k-i-pdf"></span>
                <a *ngIf="!dataItem.isClicked" class="clone-link">View</a>
                <span *ngIf="dataItem.isClicked" class="k-icon k-i-loading inner"></span>
              </span>
            </div>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>
  <app-notification-loading></app-notification-loading>
</div>
